// Auto Generated by UpdateTeamIDToPWinner
// https://www.oddsportal.com/cricket/world/icc-world-cup/outrights/
// 2023-10-31 13:35:23 +0000

export const TEAM_ID_TO_P_WINNER = {
  IND: 0.417637, // 42%
  AUS: 0.233877, // 23%
  ZAF: 0.194897, // 19%
  NZL: 0.125291, // 13%
  AFG: 0.01309, // 1%
  PAK: 0.010828, // 1%
  LKA: 0.001751, // 0%
  ENG: 0.000876, // 0%
  BGD: 0.000876, // 0%
  NLD: 0.000876, // 0%
};
